export default __webpack_public_path__ + "static/media/brownhorse1.018e8365.jpg";